module.exports = __webpack_public_path__ + "img/logo-dvg.c81af436.svg";